<template>
  <v-content>
    <div class="root">
      <Header :useType.sync="useType" />
      <div
        :style="bannerStyle"
        class="loginWrap"
      >
        <v-carousel
          :height="bannerStyle.height"
          :interval="interval"
          :hide-delimiters="true"
          flat
          class="carousel"
        >
          <v-carousel-item
            class="carousel-item"
            reverse-transition="fade"
            transition="fade"
          >
            <div
              :style="{backgroundImage:`url(${require('./images/banner/banner5/bg.jpg')}`}"
              class="imgItem banner5Item"
            >
              <div
                class="mainPanel"
                style="height: 100%;position: relative;"
              >
                <div class="banner5SideContent">
                  <img
                    :src="require('./images/banner/banner5/text.png')"
                    alt=""
                    class="banner5Text"
                  >
                  <img
                    :src="require('./images/banner/banner5/icons.png')"
                    alt=""
                    class="banner5Icons"
                  >
                </div>
              </div>
            </div>
          </v-carousel-item>
          <v-carousel-item
            class="carousel-item"
            reverse-transition="fade"
            transition="fade"
          >
            <div
              :style="{backgroundImage:`url(${require('./images/banner/banner1.jpg')}`}"
              class="imgItem"
            />
          </v-carousel-item>
          <v-carousel-item
            class="carousel-item"
            reverse-transition="fade"
            transition="fade"
          >
            <div
              :style="{backgroundImage:`url(${require('./images/banner/banner2.jpg')}`}"
              class="imgItem"
            />
          </v-carousel-item>
          <v-carousel-item
            class="carousel-item"
            reverse-transition="fade"
            transition="fade"
          >
            <div
              :style="{backgroundImage:`url(${require('./images/banner/banner3.jpg')}`}"
              class="imgItem"
            />
          </v-carousel-item>
        </v-carousel>
        <v-layout
          class="mainPanel"
          style="height: 100%;padding-top: 90px"
          align-center
        >
          <v-spacer />
          <SignInPanel :standalone="standalone" />
        </v-layout>
      </div>
      <template>
        <div
          class="mainPanel "
          style="padding-bottom: 30px"
        >
          <div
            class="text-center pt-4 font-bold"
            style="font-size: 35px"
          >
            從2020年成立至今，巧巧郎由 <span style="font-size: 1.6em">0</span> 發展至
          </div>
          <v-layout class="text-center">
            <v-flex class="numStatWrap">
              <div
                style="color: #FFC300;"
                class="numStatWrap"
              >
                <span style="font-size: 1.8em;width: 1.2em;display:inline-block;">
                  <Countup
                    :delay="1000"
                    :endVal="memberCount"
                    :options="{duration:3}"
                  />
                </span>
                <span style="font-size: 0.5em"> 萬</span>
              </div>
              <div>會員人數</div>
            </v-flex>
            <v-flex class="numStatWrap">
              <div
                style="color: #FFC300;"
                class="numStatWrap"
              >
                <span :style="`font-size: 1.8em;width: ${packageCount >= 10 ? '1.2em' : '0.5em'};display:inline-block;`">
                  <Countup
                    :delay="1000"
                    :endVal="packageCount"
                    :options="{duration:3}"
                  />
                </span>
                <span style="font-size: 0.5em"> 億</span>
              </div>
              <div>累計包裹數</div>
            </v-flex>

            <v-flex class="numStatWrap">
              <div class="pt-2">
                <span style="width: 2.5em;display:inline-block;">
                  <Countup
                    :delay="1000"
                    :endVal="97.35"
                    :options="{decimalPlaces:2,decimal:'.', duration:2}"
                  />
                </span> %
              </div>
              <div>會員滿意度</div>
            </v-flex>

            <v-flex class="numStatWrap">
              <div class="pt-2">
                <span style="width: 2.5em;display:inline-block;">
                  <Countup
                    :delay="1000"
                    :endVal="99.93"
                    :options="{decimalPlaces:2,decimal:'.', duration:2}"
                  />
                </span> %
              </div>
              <div>持續使用率</div>
            </v-flex>
          </v-layout>
        </div>

        <FbComment />
        <YoubuteVideoCard />
        <SelfStoreCard />
        <CharityCard />
        <LineFloatBtn />
      </template>

      <Footer style="flex: 1" />
    </div>
    <AliBindDialog />
    <NewDeviceNeedCellphoneCaptchaDialog />
    <DocEvent
      @scroll="onScroll"
    />
  </v-content>
</template>

<script>
import SignInPanel from './components/SignInPanel.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import NewDeviceNeedCellphoneCaptchaDialog from './components/NewDeviceNeedCellphoneCaptchaDialog.vue'
import FbComment from './components/FbComment.vue'
import SelfStoreCard from './components/SelfStoreCard.vue'
import YoubuteVideoCard from './components/YoubuteVideoCard.vue'
// import CharityList from './charity/CharityList.vue'
import CharityCard from './charity/CharityCard.vue'
import LineFloatBtn from './components/LineFloatBtn.vue'
import AliBindDialog from './ali/components/AliBindDialog.vue'

export default {
  props: { standalone: Boolean },
  components: {
    SignInPanel,
    Footer,
    Header,
    NewDeviceNeedCellphoneCaptchaDialog,
    // CharityList,
    CharityCard,
    FbComment,
    SelfStoreCard,
    YoubuteVideoCard,
    LineFloatBtn,
    AliBindDialog,
  },
  data () {
    return {
      innerHeight: window.innerHeight,
      useType: 'individual', // individual or businesse
      checkTimer: 0,
      checkCount: 0,
      delay: 1000,
      endVal: 29,
      interval: 9999999,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      }
    }
  },
  computed: {
    isChrome () {
      return this.$store.state.isChrome
    },
    installedCrx: {
      get () {
        return this.$store.state.installedCrx
      },
      set (value) {
        this.$store.commit('setInstalledCrx', value)
      }
    },
    bannerStyle () {
      return {
        // height: Math.min(722, this.innerHeight - 70 - 227 - 95) + 'px'
        // height: Math.max(390, Math.min(722, this.innerHeight - 70 - 227 - 95 - 30)) + 'px'
        height: '700px'
      }
    },
    memberCount () {
      return this.calculateGrowth(260000, 6000, 10000)
    },
    packageCount () {
      return this.calculateGrowth(900000000, 10000000, 100000000)
    }
  },
  created () {
    window.addEventListener('resize', this.resizeHandle)
    this.resizeHandle()
    if (this.isChrome) {
      this.checkInstallCrx()
      this.checkTimer = setInterval(async () => {
        this.checkInstallCrx()
      }, 5000)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandle)
    clearInterval(this.checkTimer)
  },
  methods: {
    calculateGrowth (baseCount, monthlyGrowth, divisor) {
      const baseDate = new Date('2025-01-01')
      const currentDate = new Date()

      if (currentDate < baseDate) {
        return Math.floor(baseCount / divisor)
      }

      const yearsDiff = currentDate.getFullYear() - baseDate.getFullYear()
      const monthsDiff = currentDate.getMonth() - baseDate.getMonth()
      const totalMonths = yearsDiff * 12 + monthsDiff

      const totalCount = baseCount + (totalMonths * monthlyGrowth)
      return Math.floor(totalCount / divisor)
    },
    onScroll () {
      this.interval = 10000
    },
    async checkInstallCrx () {
      this.checkCount++
      if (await this.$store.dispatch('checkInstallCrx')) {
        if (this.checkCount > 1 && !this.installedCrx) {
          location.reload()
        }
        this.installedCrx = true
      } else {
        this.installedCrx = false
      }
    },
    resizeHandle () {
      this.innerHeight = window.innerHeight
    }
  }
}
</script>

<style lang="postcss" scoped>
.root {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.loginWrap {
  /* background: url(./images/banner.jpg) center center no-repeat; */
  position: relative;
  min-height: 200px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1820px;
  width: 100%;
  margin-top: -90px;
  .carousel {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: none;
    .imgItem {
      background: #fff center center no-repeat;
      background-size: auto 100%;
      height: 100%;
    }

    .banner5Item {
      position: relative;

      .banner5SideContent {
        padding-top: 90px;
        width: calc(100vw - 600px);
        position: absolute;
        top: 50%;
        right: 380px;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .banner5Text {
        width: 50%;
        margin-right: 20px;
        min-width: 500px;
      }

      .banner5Icons {
        width: 30%;
        max-width: 370px;
        min-width: 300px;
      }
    }

    .carousel-item {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      &.fade {
        &-enter-active,
        &-leave-active,
        &-leave-to {
          transition: 0.4s opacity;
          opacity: 1;
        }
        &-enter,
        &-leave,
        &-leave-to {
          opacity: 0;
        }
      }
    }
  }

}

.textContent {
  padding: 10px 0 10px 130px;
  height: 100%;
  > * {
    line-height: 40px;
    margin: 10px 0;
    img {
      height: 40px;
      vertical-align: middle;
    }
    span {
      margin-left: 30px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.textContentWrap {
  flex: 2;
  justify-content: center;
}

.numStatWrap {
  > *:nth-child(1){
    font-size: 65px;
    line-height: 120px;
    height: 120px;
    font-weight: bold;
  }
}
</style>
